import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { CheckCircle2, ArrowRight } from "lucide-react";
import Illustration from "../ui/Illustration";

const fadeUp = {
  hidden: { opacity: 0, y: 16 },
  visible: { opacity: 1, y: 0 },
};

export default function Hero() {
  return (
    <section
      id="home"
      className="section relative overflow-hidden"
      style={{
        background:
          "linear-gradient(135deg, #e8f9fc 0%, #ffffff 40%, #eef2ff 100%)",
      }}
    >
      {/* Decorative blurred shapes */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-brand-100 rounded-full -translate-y-1/2 translate-x-1/3 opacity-40 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-accent-100 rounded-full translate-y-1/3 -translate-x-1/4 opacity-30 blur-3xl pointer-events-none" />

      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-10 sm:py-14 md:py-18 grid md:grid-cols-2 gap-10 md:gap-16 items-center">
        {/* Text content */}
        <motion.div
          initial="hidden"
          animate="visible"
          transition={{ staggerChildren: 0.1 }}
        >
          <motion.div variants={fadeUp} transition={{ duration: 0.5 }}>
            <span className="kicker">Specialiseret vikarbureau til plejesektoren</span>
          </motion.div>

          <motion.h1
            variants={fadeUp}
            transition={{ duration: 0.5 }}
            className="mt-4 text-3xl sm:text-4xl md:text-5xl font-extrabold leading-tight tracking-tight text-slate-900"
          >
            Kvalificeret vikardækning{" "}
            <span className="text-brand-500 subtle-glow">
              til kommunal sundhedspleje
            </span>
          </motion.h1>

          <motion.p
            variants={fadeUp}
            transition={{ duration: 0.5 }}
            className="mt-5 text-slate-500 text-base sm:text-lg max-w-lg leading-relaxed"
          >
            Vi leverer erfarne sygeplejersker og SOSU-assistenter til den
            kommunale plejesektor. Stabil bemanding, ordentlige vilkår og et
            personligt samarbejde I kan regne med.
          </motion.p>

          <motion.div
            variants={fadeUp}
            transition={{ duration: 0.5 }}
            className="mt-8 flex flex-col sm:flex-row gap-3"
          >
            <a href="#kontakt" className="btn btn-primary btn-lg">
              Kontakt os i dag
              <ArrowRight size={18} />
            </a>
            <Link to="/for-vikarer" className="btn btn-secondary btn-lg">
              Bliv vikar hos os
            </Link>
          </motion.div>

          <motion.ul
            variants={fadeUp}
            transition={{ duration: 0.5 }}
            className="mt-8 flex flex-wrap gap-x-6 gap-y-2"
          >
            {[
              "Plejehjem og plejecentre",
              "Hjemmeplejen",
              "Bosteder",
            ].map((text) => (
              <li
                key={text}
                className="flex items-center gap-2 text-sm text-slate-600"
              >
                <CheckCircle2
                  className="text-brand-500 shrink-0"
                  size={16}
                />
                {text}
              </li>
            ))}
          </motion.ul>
        </motion.div>

        {/* Illustration */}
        <motion.div
          initial={{ opacity: 0, scale: 0.95 }}
          animate={{ opacity: 1, scale: 1 }}
          transition={{ duration: 0.6, delay: 0.2 }}
          className="order-last"
        >
          <Illustration />
        </motion.div>
      </div>
    </section>
  );
}
